document.addEventListener('DOMContentLoaded', function() {
    // Initialize Swiper after it's loaded
    const initSwiper = () => {
        if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
            return;
        }

        const swiperProducts = new Swiper(".myProducts", {
            loop: true,
            centeredSlides: false,
            slidesPerView: 5,
            spaceBetween: 20,

            navigation: {
                nextEl: ".swiper-button-next-products",
                prevEl: ".swiper-button-prev-products",
            },

            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                },
                1200: {
                    slidesPerView: 5,
                }
            }
        });

        // Swiper (loop:true) duplica slides após o AOS calcular as posições de
        // gatilho das animações; recalcula pra evitar a seção travar em opacity:0.
        if (typeof AOS !== 'undefined') {
            AOS.refresh();
        }
    };

    initSwiper();

    // Filter functionality
        const RECENT_POSTS_COUNT = 6;
        const filterButtons = document.querySelectorAll('.filter-btn');
        const posts = document.querySelectorAll('.post');

        filterButtons.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();

                // Troca classe ativa
                filterButtons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');

                const filter = this.getAttribute('data-filter');

                posts.forEach((post, index) => {
                    // Categoria real do post (vem do backend)
                    const postCategory = post.getAttribute('data-category') || '';

                    if (filter === 'all') {
                        post.style.display = 'block';
                    } else if (filter === 'recentes') {
                        // Os posts já vêm ordenados do mais recente para o mais antigo
                        post.style.display = index < RECENT_POSTS_COUNT ? 'block' : 'none';
                    } else if (postCategory === filter) {
                        post.style.display = 'block';
                    } else {
                        post.style.display = 'none';
                    }
            });

                // Esconder/mostrar posts muda a altura da página, o que desatualiza
                // as posições de gatilho do AOS para tudo que vem depois (ex: .conheca).
                if (typeof AOS !== 'undefined') {
                    AOS.refresh();
                }
        });
    });
});
